import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { TrashIcon } from '@heroicons/react/24/outline';
import { HourglassBottom } from 'react-bootstrap-icons';

const WaitForSomeTimeNode = ({ data, id, outputEdges, onEdgeCountChange }) => {
  // Define color scheme
  const colors = {
    border: 'border-[#D6201C50]',
    rounded: 'rounded-lg',
    gradient: 'from-[#D6201C20] to-[#D6201C50]',
    borderBottom: 'border-[#D6201C50]',
    text: 'text-[#D6201C]',
    handle: 'border-2 border-[#D6201C] !bg-[#D6201C] hover:!bg-[#D6201C]'
  };
  const edgeLabels = [];
  // Add hover state
  const [isHovered, setIsHovered] = React.useState(false);

  // Format the wait time display
  const getWaitTimeDisplay = () => {
    if (data.waitTimeConfig) {
      const { value, unit } = data.waitTimeConfig;
      // Remove 's' from unit if value is 1
      const displayUnit = value === 1 ? unit.slice(0, -1) : unit;
      return `Wait for ${value} ${displayUnit}`;
    }
    return 'Wait for Some Time';
  };

  return (
    <div 
      className={`bg-white p-2 ${colors.rounded} shadow-lg border-2 ${colors.border} relative`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Delete button - Added opacity and transition */}
      <div 
        className={`absolute -top-3 left-1/2 -translate-x-1/2 w-5 h-5 bg-gray-200 rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-600 hover:text-white z-10 transition-opacity ${isHovered ? 'opacity-100' : 'opacity-0'}`}
        onClick={(e) => {
          e.stopPropagation();
          if (data.onDelete) {
            data.onDelete(id);
          }
        }}
      >
        <TrashIcon className='w-4 h-4 p-0.5 hover:text-white text-black'/>
      </div>

      {/* Header section - Updated to show wait time */}
      <div className={`p-3 py-5 bg-gradient-to-r ${colors.gradient} border-b ${colors.borderBottom} ${colors.rounded}`}>
        <div className="flex items-center gap-2">
          <HourglassBottom className='w-8 h-8 p-1.5 bg-white text-[#D6201C] rounded-full'/>
          <div className="flex flex-col">
            <span className={`font-semibold ${colors.text}`}>
              {getWaitTimeDisplay()}
            </span>
          </div>
        </div>
      </div>

      <Handle
        type="target"
        position={Position.Left}
        className={`w-4 h-4 ${colors.handle}`}
      />
      
      {/* Output handles */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 h-[50px]">
        {Array.from({ length: outputEdges }).map((_, index) => (
          <>
            <Handle
              key={`output-${index}`}        
              type="source"
              position={Position.Right}
              id={`output-${index}`}
              className="w-3 h-3 !bg-[#D6201C] hover:!bg-[#D6201C]"
              style={{ 
                top: `${((index + 1) * 100) / (outputEdges + 1)}%`
              }}
            />
          </>
        ))}
      </div>
    </div>
  );
};

export default WaitForSomeTimeNode; 
